import { requestJson } from "./http";

export function fetchAdminTimecards({ status = "", weekStartDate = "" } = {}) {
  const query = new URLSearchParams();

  if (status) {
    query.set("status", status);
  }

  if (weekStartDate) {
    query.set("weekStartDate", weekStartDate);
  }

  const queryString = query.toString();
  return requestJson(`/api/admin/timecards${queryString ? `?${queryString}` : ""}`);
}

export function approveTimecard(timecardId) {
  return requestJson(`/api/admin/timecards/${timecardId}/approve`, {
    method: "POST"
  });
}

export function fetchAdminContractors() {
  return requestJson("/api/admin/contractors");
}

export function createAdminContractor(contractor) {
  return requestJson("/api/admin/contractors", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(contractor)
  });
}

export function updateAdminContractor(contractorId, contractor) {
  return requestJson(`/api/admin/contractors/${contractorId}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(contractor)
  });
}

export function createHospital(hospital) {
  return requestJson("/api/admin/hospitals", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(hospital)
  });
}

export function updateHospital(hospitalId, hospital) {
  return requestJson(`/api/admin/hospitals/${hospitalId}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(hospital)
  });
}

export function adminCreateTimecard(timecard) {
  return requestJson("/api/admin/timecards", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(timecard)
  });
}

export function adminUpdateTimecard(timecardId, timecard) {
  return requestJson(`/api/admin/timecards/${timecardId}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(timecard)
  });
}
